import { Translations } from "@aws-amplify/ui-components";

/* stupid script to generate the below dict
import { dict } from "./AmplifyI18n"; // from
const translationKeys = Object.keys(Translations);
const translationValues = Object.values(Translations);
console.log("export const i18nAuthDict = {");
Object.keys(dict).forEach((languageKey) => {
	console.log(`	${languageKey}: {`);
	Object.keys(dict[languageKey]).forEach((dictKey) => {
		if (
			translationValues.some((translationValue) => translationValue === dictKey)
		) {
			console.log(`		[Translations.${translationKeys[translationValues.findIndex((value) => value === dictKey)]}]: "${dict[languageKey][dictKey]}",`);
		} else {
			console.log(`		"${dictKey}": "${dict[languageKey][dictKey]}",`);
		}
	});
	console.log("		// Undefined Translations");
	const map = new Map(Object.entries(dict[languageKey]));
	translationKeys
		.filter((translationKey) =>	!map.has(translationKey))
		.forEach((translationKey) => {
			console.log(`		// [Translations.${translationKey}]: "…", // en: "${Translations[translationKey]}"`);
		});
	console.log(`	},`);
});
console.log("}")
/**/

export const i18nAuthDict = {
	de: {
		[Translations.SIGN_IN_ACTION]: "Anmelden",
		"Sign Up": "Registrieren",
		[Translations.SIGN_OUT]: "Abmelden",
		[Translations.SIGN_IN_HEADER_TEXT]: "Melden Sie sich mit Ihrem Account an",
		[Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "Benutzername",
		[Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "Passwort",
		[Translations.USERNAME_PLACEHOLDER]: "Geben Sie Ihren Benutzernamen ein",
		[Translations.PASSWORD_PLACEHOLDER]: "Geben Sie Ihr Passwort ein",
		[Translations.NO_ACCOUNT_TEXT]: "Kein Account?",
		[Translations.FORGOT_PASSWORD_TEXT]: "Passwort vergessen?",
		[Translations.RESET_PASSWORD_TEXT]: "Passwort zurücksetzen",
		"User does not exist.": "Dieser Benutzer existiert nicht.",
		"User already exists.": "Dieser Benutzer existiert bereits.",
		"Incorrect username or password.":
			"Falscher Benutzername oder falsches Passwort.",
		"Invalid password format": "Ungültiges Passwort-Format",
		[Translations.CREATE_ACCOUNT_TEXT]: "Hier registrieren",
		"Forgot Password": "Passwort vergessen",
		[Translations.CHANGE_PASSWORD]: "Passwort ändern",
		"New Password": "Neues Passwort",
		[Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "E-Mail",
		[Translations.VERIFY_CONTACT_PHONE_LABEL]: "Telefonnummer",
		"Confirm a Code": "Code bestätigen",
		"Confirm Sign In": "Anmeldung bestätigen",
		"Confirm Sign Up": "Registrierung bestätigen",
		[Translations.BACK_TO_SIGN_IN]: "Zurück zur Anmeldung",
		[Translations.SEND_CODE]: "Code senden",
		[Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "Bestätigen",
		[Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "Code erneut senden",
		[Translations.SUBMIT]: "Abschicken",
		Skip: "Überspringen",
		[Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "Verifizieren",
		"Verify Contact": "Kontakt verifizieren",
		Code: "Code",
		[Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "Bestätigungs-Code",
		"Lost your code? ": "Code verloren? ",
		[Translations.VERIFY_CONTACT_HEADER_TEXT]:
			"Zurücksetzen des Account benötigt einen verifizierten Account",
		"Invalid phone number format":
			"Ungültiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900",
		[Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "Account erstellen",
		[Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "Schon registriert? ",
		[Translations.SIGN_IN_TEXT]: "Anmelden",
		[Translations.SIGN_UP_HEADER_TEXT]: "Erstelle einen neuen Account",
		[Translations.RESET_YOUR_PASSWORD]: "Zurücksetzen des Passworts",
		"An account with the given email already exists.":
			"Ein Account mit dieser Email existiert bereits.",
		[Translations.EMPTY_USERNAME]: "Benutzername darf nicht leer sein",
		"Password attempts exceeded":
			"Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht",
		// Undefined Translations
		[Translations.BACK_TO_SIGN_IN]: "Zurück zur Anmeldung", // en: "Back to Sign In"
		[Translations.CHANGE_PASSWORD_ACTION]: "Ändern", // en: "Change"
		[Translations.CHANGE_PASSWORD]: "Passwort ändern", // en: "Change Password"
		[Translations.CODE_LABEL]: "Bestätigungs-Code", // en: "Verification code"
		[Translations.CODE_PLACEHOLDER]: "Code eingeben", // en: "Enter code"
		// [Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "…", // en: "Confirmation Code"
		// [Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]: "…", // en: "Enter your code"
		// [Translations.CONFIRM_SIGN_UP_HEADER_TEXT]: "…", // en: "Confirm Sign up"
		// [Translations.CONFIRM_SIGN_UP_LOST_CODE]: "…", // en: "Lost your code?"
		// [Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "…", // en: "Resend Code"
		// [Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Confirm"
		// [Translations.CONFIRM_SMS_CODE]: "…", // en: "Confirm SMS Code"
		// [Translations.CONFIRM_TOTP_CODE]: "…", // en: "Confirm TOTP Code"
		[Translations.CONFIRM]: "Bestätigen", // en: "Confirm"
		[Translations.EMAIL_LABEL]: "E-Mail-Adresse *", // en: "Email Address *"
		// [Translations.EMAIL_PLACEHOLDER]: "…", // en: "Enter your email address"
		// [Translations.LESS_THAN_TWO_MFA_VALUES_MESSAGE]: "…", // en: "Less than two MFA types available"
		// [Translations.NEW_PASSWORD_LABEL]: "…", // en: "New password"
		// [Translations.NEW_PASSWORD_PLACEHOLDER]: "…", // en: "Enter your new password"
		// [Translations.USERNAME_REMOVE_WHITESPACE]: "…", // en: "Username cannot contain whitespace"
		// [Translations.PASSWORD_REMOVE_WHITESPACE]: "…", // en: "Password cannot start or end with whitespace"
		[Translations.PASSWORD_LABEL]: "Passwort *", // en: "Password *"
		// [Translations.PASSWORD_PLACEHOLDER]: "…", // en: "Enter your password"
		[Translations.PHONE_LABEL]: "Telefonnummer *", // en: "Phone Number *"
		[Translations.PHONE_PLACEHOLDER]: "(123) 456789-0", // en: "(555) 555-1212"
		// [Translations.QR_CODE_ALT]: "…", // en: "qrcode"
		// [Translations.RESET_PASSWORD_TEXT]: "…", // en: "Reset password"
		// [Translations.RESET_YOUR_PASSWORD]: "…", // en: "Reset your password"
		// [Translations.SELECT_MFA_TYPE_HEADER_TEXT]: "…", // en: "Select MFA Type"
		// [Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify"
		// [Translations.SEND_CODE]: "…", // en: "Send Code"
		// [Translations.SUBMIT]: "…", // en: "Submit"
		// [Translations.SETUP_TOTP_REQUIRED]: "…", // en: "TOTP needs to be configured"
		// [Translations.SIGN_IN_ACTION]: "…", // en: "Sign In"
		// [Translations.SIGN_IN_HEADER_TEXT]: "…", // en: "Sign in to your account"
		// [Translations.SIGN_IN_TEXT]: "…", // en: "Sign in"
		// [Translations.SIGN_IN_WITH_AMAZON]: "…", // en: "Sign in with Amazon"
		// [Translations.SIGN_IN_WITH_AUTH0]: "…", // en: "Sign in with Auth0"
		// [Translations.SIGN_IN_WITH_AWS]: "…", // en: "Sign in with AWS"
		// [Translations.SIGN_IN_WITH_FACEBOOK]: "…", // en: "Sign in with Facebook"
		// [Translations.SIGN_IN_WITH_GOOGLE]: "…", // en: "Sign in with Google"
		// [Translations.SIGN_OUT]: "…", // en: "Sign Out"
		// [Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "…", // en: "Email"
		// [Translations.SIGN_UP_HEADER_TEXT]: "…", // en: "Create a new account"
		// [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "…", // en: "Password"
		// [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Create Account"
		// [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "…", // en: "Username"
		// [Translations.SUCCESS_MFA_TYPE]: "…", // en: "Success! Your MFA Type is now:"
		// [Translations.TOTP_HEADER_TEXT]: "…", // en: "Scan then enter verification code"
		// [Translations.TOTP_LABEL]: "…", // en: "Enter Security Code:"
		// [Translations.TOTP_ISSUER]: "…", // en: "AWSCognito"
		// [Translations.TOTP_SETUP_FAILURE]: "…", // en: "TOTP Setup has failed"
		// [Translations.TOTP_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify Security Token"
		// [Translations.TOTP_SUCCESS_MESSAGE]: "…", // en: "Setup TOTP successfully!"
		// [Translations.UNABLE_TO_SETUP_MFA_AT_THIS_TIME]: "…", // en: "Failed! Unable to configure MFA at this time"
		[Translations.USERNAME_LABEL]: "Benutzername *", // en: "Username *"
		// [Translations.USERNAME_PLACEHOLDER]: "…", // en: "Enter your username"
		// [Translations.VERIFY_CONTACT_EMAIL_LABEL]: "…", // en: "Email"
		// [Translations.VERIFY_CONTACT_HEADER_TEXT]: "…", // en: "Account recovery requires verified contact information"
		// [Translations.VERIFY_CONTACT_PHONE_LABEL]: "…", // en: "Phone Number"
		// [Translations.VERIFY_CONTACT_SUBMIT_LABEL]: "…", // en: "Submit"
		// [Translations.VERIFY_CONTACT_VERIFY_LABEL]: "…", // en: "Verify"
		// [Translations.ADDRESS_LABEL]: "…", // en: "Address"
		// [Translations.ADDRESS_PLACEHOLDER]: "…", // en: "Enter your address"
		// [Translations.NICKNAME_LABEL]: "…", // en: "Nickname"
		// [Translations.NICKNAME_PLACEHOLDER]: "…", // en: "Enter your nickname"
		// [Translations.BIRTHDATE_LABEL]: "…", // en: "Birthday"
		// [Translations.BIRTHDATE_PLACEHOLDER]: "…", // en: "Enter your birthday"
		// [Translations.PICTURE_LABEL]: "…", // en: "Picture URL"
		// [Translations.PICTURE_PLACEHOLDER]: "…", // en: "Enter your picture URL"
		// [Translations.FAMILY_NAME_LABEL]: "…", // en: "Family Name"
		// [Translations.FAMILY_NAME_PLACEHOLDER]: "…", // en: "Enter your family name"
		// [Translations.PREFERRED_USERNAME_LABEL]: "…", // en: "Preferred Username"
		// [Translations.PREFERRED_USERNAME_PLACEHOLDER]: "…", // en: "Enter your preferred username"
		// [Translations.GENDER_LABEL]: "…", // en: "Gender"
		// [Translations.GENDER_PLACEHOLDER]: "…", // en: "Enter your gender"
		// [Translations.PROFILE_LABEL]: "…", // en: "Profile URL"
		// [Translations.PROFILE_PLACEHOLDER]: "…", // en: "Enter your profile URL"
		// [Translations.GIVEN_NAME_LABEL]: "…", // en: "First Name"
		// [Translations.GIVEN_NAME_PLACEHOLDER]: "…", // en: "Enter your first name"
		// [Translations.ZONEINFO_LABEL]: "…", // en: "Time zone"
		// [Translations.ZONEINFO_PLACEHOLDER]: "…", // en: "Enter your time zone"
		// [Translations.LOCALE_LABEL]: "…", // en: "Locale"
		// [Translations.LOCALE_PLACEHOLDER]: "…", // en: "Enter your locale"
		// [Translations.UPDATED_AT_LABEL]: "…", // en: "Updated At"
		// [Translations.UPDATED_AT_PLACEHOLDER]: "…", // en: "Enter the time the information was last updated"
		// [Translations.MIDDLE_NAME_LABEL]: "…", // en: "Middle Name"
		// [Translations.MIDDLE_NAME_PLACEHOLDER]: "…", // en: "Enter your middle name"
		// [Translations.WEBSITE_LABEL]: "…", // en: "Website"
		// [Translations.WEBSITE_PLACEHOLDER]: "…", // en: "Enter your website"
		// [Translations.NAME_LABEL]: "…", // en: "Full Name"
		// [Translations.NAME_PLACEHOLDER]: "…", // en: "Enter your full name"
		// [Translations.PHOTO_PICKER_TITLE]: "…", // en: "Picker Title"
		// [Translations.PHOTO_PICKER_HINT]: "…", // en: "Ancillary text or content may occupy this space here"
		// [Translations.PHOTO_PICKER_PLACEHOLDER_HINT]: "…", // en: "Placeholder hint"
		// [Translations.PHOTO_PICKER_BUTTON_TEXT]: "…", // en: "Button"
		// [Translations.IMAGE_PICKER_TITLE]: "…", // en: "Add Profile Photo"
		// [Translations.IMAGE_PICKER_HINT]: "…", // en: "Preview the image before upload"
		// [Translations.IMAGE_PICKER_PLACEHOLDER_HINT]: "…", // en: "Tap to image select"
		// [Translations.IMAGE_PICKER_BUTTON_TEXT]: "…", // en: "Upload"
		// [Translations.PICKER_TEXT]: "…", // en: "Pick a file"
		// [Translations.TEXT_FALLBACK_CONTENT]: "…", // en: "Fallback Content"
		// [Translations.CONFIRM_SIGN_UP_FAILED]: "…", // en: "Confirm Sign Up Failed"
		// [Translations.SIGN_UP_FAILED]: "…", // en: "Sign Up Failed"
		// [Translations.DEFAULT_MSG]: "…", // en: "Authentication Error"
		// [Translations.EMPTY_EMAIL]: "…", // en: "Email cannot be empty"
		// [Translations.EMPTY_PHONE]: "…", // en: "Phone number cannot be empty"
		// [Translations.EMPTY_USERNAME]: "…", // en: "Username cannot be empty"
		// [Translations.INVALID_USERNAME]: "…", // en: "The username should either be a string or one of the sign in types"
		// [Translations.EMPTY_PASSWORD]: "…", // en: "Password cannot be empty"
		// [Translations.EMPTY_CODE]: "…", // en: "Confirmation code cannot be empty"
		// [Translations.SIGN_UP_ERROR]: "…", // en: "Error creating account"
		// [Translations.NO_MFA]: "…", // en: "No valid MFA method provided"
		// [Translations.INVALID_MFA]: "…", // en: "Invalid MFA type"
		// [Translations.EMPTY_CHALLENGE]: "…", // en: "Challenge response cannot be empty"
		// [Translations.NO_USER_SESSION]: "…", // en: "Failed to get the session because the user is empty"
		// [Translations.NETWORK_ERROR]: "…", // en: "Network Error"
		// [Translations.DEVICE_CONFIG]: "…", // en: "Device tracking has not been configured in this User Pool"
		// [Translations.CHATBOT_TITLE]: "…", // en: "ChatBot Lex"
		// [Translations.TEXT_INPUT_PLACEHOLDER]: "…", // en: "Write a message"
		// [Translations.VOICE_INPUT_PLACEHOLDER]: "…", // en: "Click mic to speak"
		// [Translations.CHAT_DISABLED_ERROR]: "…", // en: "Error: Either voice or text must be enabled for the chatbot"
		// [Translations.NO_BOT_NAME_ERROR]: "…", // en: "Error: Bot name must be provided to ChatBot"
	},
	fr: {
		Hello: "Bonjour",
		"Loading...": "Chargement...",
		[Translations.SIGN_IN_ACTION]: "Se connecter",
		"Sign In with Amazon": "Se connecter avec Amazon",
		"Sign In with Facebook": "Se connecter avec Facebook",
		"Sign In with Google": "Se connecter avec Google",
		[Translations.SIGN_IN_WITH_AWS]: "Se connecter avec AWS",
		"Sign Up": "S'inscrire",
		[Translations.SIGN_OUT]: "Déconnexion",
		"Forgot Password": "Mot de passe oublié",
		[Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "Nom d'utilisateur",
		[Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "Mot de passe",
		[Translations.CHANGE_PASSWORD]: "Modifier le mot de passe",
		[Translations.CHANGE_PASSWORD_ACTION]: "Modifier",
		"New Password": "Nouveau mot de passe",
		[Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "Email",
		[Translations.VERIFY_CONTACT_PHONE_LABEL]: "Numéro de téléphone",
		"Confirm a Code": "Confirmer un code",
		"Confirm Sign In": "Confirmer la connexion",
		"Confirm Sign Up": "Confirmer l'inscription",
		[Translations.BACK_TO_SIGN_IN]: "Retour à la connexion",
		Send: "Envoyer",
		[Translations.SEND_CODE]: "M'envoyer un code",
		[Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "Confirmer",
		SMS: "SMS",
		[Translations.CONFIRM_SMS_CODE]: "Confirmer le code SMS",
		[Translations.CONFIRM_TOTP_CODE]: "Confirmer le code TOTP",
		"Resend a Code": "Renvoyer un code",
		[Translations.SUBMIT]: "Soumettre",
		Skip: "Passer",
		[Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "Vérifier",
		"Verify Contact": "Vérifier le contact",
		Code: "Code",
		[Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "Code de confirmation",
		[Translations.VERIFY_CONTACT_HEADER_TEXT]:
			"La récupération du compte nécessite des informations de contact vérifiées",
		"User does not exist": "L'utilisateur n'existe pas",
		"User already exists": "L'utilisateur existe déjà",
		"Incorrect username or password": "Identifiant ou mot de passe incorrect",
		"Invalid password format": "Format de mot de passe invalide",
		"Invalid phone number format":
			"Format de numéro de téléphone invalide. Veuillez utiliser un format +12345678900",
		"Username/client id combination not found.": "L'utilisateur n'existe pas",
		"Network error": "Erreur réseau",
		[Translations.SIGN_IN_HEADER_TEXT]: "Connexion à votre compte",
		"Forget your password? ": "Mot de passe oublié ? ",
		[Translations.RESET_PASSWORD_TEXT]: "Réinitialisez votre mot de passe",
		"No account? ": "Pas de compte ? ",
		[Translations.CREATE_ACCOUNT_TEXT]: "Créer un compte",
		[Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "Créer un compte",
		"Have an account? ": "Déjà un compte ? ",
		[Translations.SIGN_IN_TEXT]: "Se connecter",
		[Translations.SIGN_UP_HEADER_TEXT]: "Créer un nouveau compte",
		[Translations.RESET_YOUR_PASSWORD]: "Réinitialisez votre mot de passe",
		[Translations.USERNAME_PLACEHOLDER]: "Saisissez votre nom d'utilisateur",
		[Translations.PASSWORD_PLACEHOLDER]: "Saisissez votre mot de passe",
		"Enter your phone number": "Saisissez votre numéro de téléphone",
		"Enter your email": "Saisissez votre adresse email",
		[Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]:
			"Saisissez cotre code de confirmation",
		"Lost your code? ": "Vous avez perdu votre code ? ",
		[Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "Renvoyer le code",
		or: "ou",
		"An account with the given email already exists.":
			"Un utilisateur avec cette adresse email existe déjà.",
		[Translations.EMPTY_USERNAME]: "Le nom d'utilisateur doit être renseigné",
		// Undefined Translations
		// [Translations.BACK_TO_SIGN_IN]: "…", // en: "Back to Sign In"
		// [Translations.CHANGE_PASSWORD_ACTION]: "…", // en: "Change"
		// [Translations.CHANGE_PASSWORD]: "…", // en: "Change Password"
		// [Translations.CODE_LABEL]: "…", // en: "Verification code"
		// [Translations.CODE_PLACEHOLDER]: "…", // en: "Enter code"
		// [Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "…", // en: "Confirmation Code"
		// [Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]: "…", // en: "Enter your code"
		// [Translations.CONFIRM_SIGN_UP_HEADER_TEXT]: "…", // en: "Confirm Sign up"
		// [Translations.CONFIRM_SIGN_UP_LOST_CODE]: "…", // en: "Lost your code?"
		// [Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "…", // en: "Resend Code"
		// [Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Confirm"
		// [Translations.CONFIRM_SMS_CODE]: "…", // en: "Confirm SMS Code"
		// [Translations.CONFIRM_TOTP_CODE]: "…", // en: "Confirm TOTP Code"
		// [Translations.CONFIRM]: "…", // en: "Confirm"
		// [Translations.CREATE_ACCOUNT_TEXT]: "…", // en: "Create account"
		// [Translations.EMAIL_LABEL]: "…", // en: "Email Address *"
		// [Translations.EMAIL_PLACEHOLDER]: "…", // en: "Enter your email address"
		// [Translations.FORGOT_PASSWORD_TEXT]: "…", // en: "Forgot your password?"
		// [Translations.LESS_THAN_TWO_MFA_VALUES_MESSAGE]: "…", // en: "Less than two MFA types available"
		// [Translations.NEW_PASSWORD_LABEL]: "…", // en: "New password"
		// [Translations.NEW_PASSWORD_PLACEHOLDER]: "…", // en: "Enter your new password"
		// [Translations.NO_ACCOUNT_TEXT]: "…", // en: "No account?"
		// [Translations.USERNAME_REMOVE_WHITESPACE]: "…", // en: "Username cannot contain whitespace"
		// [Translations.PASSWORD_REMOVE_WHITESPACE]: "…", // en: "Password cannot start or end with whitespace"
		// [Translations.PASSWORD_LABEL]: "…", // en: "Password *"
		// [Translations.PASSWORD_PLACEHOLDER]: "…", // en: "Enter your password"
		// [Translations.PHONE_LABEL]: "…", // en: "Phone Number *"
		// [Translations.PHONE_PLACEHOLDER]: "…", // en: "(555) 555-1212"
		// [Translations.QR_CODE_ALT]: "…", // en: "qrcode"
		// [Translations.RESET_PASSWORD_TEXT]: "…", // en: "Reset password"
		// [Translations.RESET_YOUR_PASSWORD]: "…", // en: "Reset your password"
		// [Translations.SELECT_MFA_TYPE_HEADER_TEXT]: "…", // en: "Select MFA Type"
		// [Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify"
		// [Translations.SEND_CODE]: "…", // en: "Send Code"
		// [Translations.SUBMIT]: "…", // en: "Submit"
		// [Translations.SETUP_TOTP_REQUIRED]: "…", // en: "TOTP needs to be configured"
		// [Translations.SIGN_IN_ACTION]: "…", // en: "Sign In"
		// [Translations.SIGN_IN_HEADER_TEXT]: "…", // en: "Sign in to your account"
		// [Translations.SIGN_IN_TEXT]: "…", // en: "Sign in"
		// [Translations.SIGN_IN_WITH_AMAZON]: "…", // en: "Sign in with Amazon"
		// [Translations.SIGN_IN_WITH_AUTH0]: "…", // en: "Sign in with Auth0"
		// [Translations.SIGN_IN_WITH_AWS]: "…", // en: "Sign in with AWS"
		// [Translations.SIGN_IN_WITH_FACEBOOK]: "…", // en: "Sign in with Facebook"
		// [Translations.SIGN_IN_WITH_GOOGLE]: "…", // en: "Sign in with Google"
		// [Translations.SIGN_OUT]: "…", // en: "Sign Out"
		// [Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "…", // en: "Email"
		// [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "…", // en: "Have an account?"
		// [Translations.SIGN_UP_HEADER_TEXT]: "…", // en: "Create a new account"
		// [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "…", // en: "Password"
		// [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Create Account"
		// [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "…", // en: "Username"
		// [Translations.SUCCESS_MFA_TYPE]: "…", // en: "Success! Your MFA Type is now:"
		// [Translations.TOTP_HEADER_TEXT]: "…", // en: "Scan then enter verification code"
		// [Translations.TOTP_LABEL]: "…", // en: "Enter Security Code:"
		// [Translations.TOTP_ISSUER]: "…", // en: "AWSCognito"
		// [Translations.TOTP_SETUP_FAILURE]: "…", // en: "TOTP Setup has failed"
		// [Translations.TOTP_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify Security Token"
		// [Translations.TOTP_SUCCESS_MESSAGE]: "…", // en: "Setup TOTP successfully!"
		// [Translations.UNABLE_TO_SETUP_MFA_AT_THIS_TIME]: "…", // en: "Failed! Unable to configure MFA at this time"
		// [Translations.USERNAME_LABEL]: "…", // en: "Username *"
		// [Translations.USERNAME_PLACEHOLDER]: "…", // en: "Enter your username"
		// [Translations.VERIFY_CONTACT_EMAIL_LABEL]: "…", // en: "Email"
		// [Translations.VERIFY_CONTACT_HEADER_TEXT]: "…", // en: "Account recovery requires verified contact information"
		// [Translations.VERIFY_CONTACT_PHONE_LABEL]: "…", // en: "Phone Number"
		// [Translations.VERIFY_CONTACT_SUBMIT_LABEL]: "…", // en: "Submit"
		// [Translations.VERIFY_CONTACT_VERIFY_LABEL]: "…", // en: "Verify"
		// [Translations.ADDRESS_LABEL]: "…", // en: "Address"
		// [Translations.ADDRESS_PLACEHOLDER]: "…", // en: "Enter your address"
		// [Translations.NICKNAME_LABEL]: "…", // en: "Nickname"
		// [Translations.NICKNAME_PLACEHOLDER]: "…", // en: "Enter your nickname"
		// [Translations.BIRTHDATE_LABEL]: "…", // en: "Birthday"
		// [Translations.BIRTHDATE_PLACEHOLDER]: "…", // en: "Enter your birthday"
		// [Translations.PICTURE_LABEL]: "…", // en: "Picture URL"
		// [Translations.PICTURE_PLACEHOLDER]: "…", // en: "Enter your picture URL"
		// [Translations.FAMILY_NAME_LABEL]: "…", // en: "Family Name"
		// [Translations.FAMILY_NAME_PLACEHOLDER]: "…", // en: "Enter your family name"
		// [Translations.PREFERRED_USERNAME_LABEL]: "…", // en: "Preferred Username"
		// [Translations.PREFERRED_USERNAME_PLACEHOLDER]: "…", // en: "Enter your preferred username"
		// [Translations.GENDER_LABEL]: "…", // en: "Gender"
		// [Translations.GENDER_PLACEHOLDER]: "…", // en: "Enter your gender"
		// [Translations.PROFILE_LABEL]: "…", // en: "Profile URL"
		// [Translations.PROFILE_PLACEHOLDER]: "…", // en: "Enter your profile URL"
		// [Translations.GIVEN_NAME_LABEL]: "…", // en: "First Name"
		// [Translations.GIVEN_NAME_PLACEHOLDER]: "…", // en: "Enter your first name"
		// [Translations.ZONEINFO_LABEL]: "…", // en: "Time zone"
		// [Translations.ZONEINFO_PLACEHOLDER]: "…", // en: "Enter your time zone"
		// [Translations.LOCALE_LABEL]: "…", // en: "Locale"
		// [Translations.LOCALE_PLACEHOLDER]: "…", // en: "Enter your locale"
		// [Translations.UPDATED_AT_LABEL]: "…", // en: "Updated At"
		// [Translations.UPDATED_AT_PLACEHOLDER]: "…", // en: "Enter the time the information was last updated"
		// [Translations.MIDDLE_NAME_LABEL]: "…", // en: "Middle Name"
		// [Translations.MIDDLE_NAME_PLACEHOLDER]: "…", // en: "Enter your middle name"
		// [Translations.WEBSITE_LABEL]: "…", // en: "Website"
		// [Translations.WEBSITE_PLACEHOLDER]: "…", // en: "Enter your website"
		// [Translations.NAME_LABEL]: "…", // en: "Full Name"
		// [Translations.NAME_PLACEHOLDER]: "…", // en: "Enter your full name"
		// [Translations.PHOTO_PICKER_TITLE]: "…", // en: "Picker Title"
		// [Translations.PHOTO_PICKER_HINT]: "…", // en: "Ancillary text or content may occupy this space here"
		// [Translations.PHOTO_PICKER_PLACEHOLDER_HINT]: "…", // en: "Placeholder hint"
		// [Translations.PHOTO_PICKER_BUTTON_TEXT]: "…", // en: "Button"
		// [Translations.IMAGE_PICKER_TITLE]: "…", // en: "Add Profile Photo"
		// [Translations.IMAGE_PICKER_HINT]: "…", // en: "Preview the image before upload"
		// [Translations.IMAGE_PICKER_PLACEHOLDER_HINT]: "…", // en: "Tap to image select"
		// [Translations.IMAGE_PICKER_BUTTON_TEXT]: "…", // en: "Upload"
		// [Translations.PICKER_TEXT]: "…", // en: "Pick a file"
		// [Translations.TEXT_FALLBACK_CONTENT]: "…", // en: "Fallback Content"
		// [Translations.CONFIRM_SIGN_UP_FAILED]: "…", // en: "Confirm Sign Up Failed"
		// [Translations.SIGN_UP_FAILED]: "…", // en: "Sign Up Failed"
		// [Translations.DEFAULT_MSG]: "…", // en: "Authentication Error"
		// [Translations.EMPTY_EMAIL]: "…", // en: "Email cannot be empty"
		// [Translations.EMPTY_PHONE]: "…", // en: "Phone number cannot be empty"
		// [Translations.EMPTY_USERNAME]: "…", // en: "Username cannot be empty"
		// [Translations.INVALID_USERNAME]: "…", // en: "The username should either be a string or one of the sign in types"
		// [Translations.EMPTY_PASSWORD]: "…", // en: "Password cannot be empty"
		// [Translations.EMPTY_CODE]: "…", // en: "Confirmation code cannot be empty"
		// [Translations.SIGN_UP_ERROR]: "…", // en: "Error creating account"
		// [Translations.NO_MFA]: "…", // en: "No valid MFA method provided"
		// [Translations.INVALID_MFA]: "…", // en: "Invalid MFA type"
		// [Translations.EMPTY_CHALLENGE]: "…", // en: "Challenge response cannot be empty"
		// [Translations.NO_USER_SESSION]: "…", // en: "Failed to get the session because the user is empty"
		// [Translations.NETWORK_ERROR]: "…", // en: "Network Error"
		// [Translations.DEVICE_CONFIG]: "…", // en: "Device tracking has not been configured in this User Pool"
		// [Translations.CHATBOT_TITLE]: "…", // en: "ChatBot Lex"
		// [Translations.TEXT_INPUT_PLACEHOLDER]: "…", // en: "Write a message"
		// [Translations.VOICE_INPUT_PLACEHOLDER]: "…", // en: "Click mic to speak"
		// [Translations.CHAT_DISABLED_ERROR]: "…", // en: "Error: Either voice or text must be enabled for the chatbot"
		// [Translations.NO_BOT_NAME_ERROR]: "…", // en: "Error: Bot name must be provided to ChatBot"
	},
	es: {
		[Translations.SIGN_IN_ACTION]: "Registrarse",
		"Sign Up": "Regístrate",
		[Translations.SIGN_OUT]: "Desconectar",
		"Forgot Password": "Se te olvidó tu contraseña",
		[Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "Nombre de usuario",
		[Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "Contraseña",
		[Translations.CHANGE_PASSWORD]: "Cambia la contraseña",
		"New Password": "Nueva contraseña",
		[Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "Email",
		[Translations.VERIFY_CONTACT_PHONE_LABEL]: "Número de teléfono",
		"Confirm a Code": "Confirmar un código",
		"Confirm Sign In": "Confirmar inicio de sesión",
		"Confirm Sign Up": "Confirmar Registrarse",
		[Translations.BACK_TO_SIGN_IN]: "Volver a Iniciar sesión",
		[Translations.SEND_CODE]: "Enviar código",
		[Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "Confirmar",
		"Resend a Code": "Reenviar un código",
		[Translations.SUBMIT]: "Enviar",
		Skip: "Omitir",
		[Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "Verificar",
		"Verify Contact": "Verificar contacto",
		Code: "Código",
		[Translations.VERIFY_CONTACT_HEADER_TEXT]:
			"La recuperación de la cuenta requiere información de contacto verificada",
		"User does not exist": "el usuario no existe",
		"User already exists": "El usuario ya existe",
		"Incorrect username or password":
			"Nombre de usuario o contraseña incorrecta",
		"Invalid password format": "Formato de contraseña inválido",
		"Invalid phone number format":
			"Formato de número de teléfono inválido. Utilice el formato de número de teléfono +12345678900",
		// Undefined Translations
		// [Translations.BACK_TO_SIGN_IN]: "…", // en: "Back to Sign In"
		// [Translations.CHANGE_PASSWORD_ACTION]: "…", // en: "Change"
		// [Translations.CHANGE_PASSWORD]: "…", // en: "Change Password"
		// [Translations.CODE_LABEL]: "…", // en: "Verification code"
		// [Translations.CODE_PLACEHOLDER]: "…", // en: "Enter code"
		// [Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "…", // en: "Confirmation Code"
		// [Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]: "…", // en: "Enter your code"
		// [Translations.CONFIRM_SIGN_UP_HEADER_TEXT]: "…", // en: "Confirm Sign up"
		// [Translations.CONFIRM_SIGN_UP_LOST_CODE]: "…", // en: "Lost your code?"
		// [Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "…", // en: "Resend Code"
		// [Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Confirm"
		// [Translations.CONFIRM_SMS_CODE]: "…", // en: "Confirm SMS Code"
		// [Translations.CONFIRM_TOTP_CODE]: "…", // en: "Confirm TOTP Code"
		// [Translations.CONFIRM]: "…", // en: "Confirm"
		// [Translations.CREATE_ACCOUNT_TEXT]: "…", // en: "Create account"
		// [Translations.EMAIL_LABEL]: "…", // en: "Email Address *"
		// [Translations.EMAIL_PLACEHOLDER]: "…", // en: "Enter your email address"
		// [Translations.FORGOT_PASSWORD_TEXT]: "…", // en: "Forgot your password?"
		// [Translations.LESS_THAN_TWO_MFA_VALUES_MESSAGE]: "…", // en: "Less than two MFA types available"
		// [Translations.NEW_PASSWORD_LABEL]: "…", // en: "New password"
		// [Translations.NEW_PASSWORD_PLACEHOLDER]: "…", // en: "Enter your new password"
		// [Translations.NO_ACCOUNT_TEXT]: "…", // en: "No account?"
		// [Translations.USERNAME_REMOVE_WHITESPACE]: "…", // en: "Username cannot contain whitespace"
		// [Translations.PASSWORD_REMOVE_WHITESPACE]: "…", // en: "Password cannot start or end with whitespace"
		// [Translations.PASSWORD_LABEL]: "…", // en: "Password *"
		// [Translations.PASSWORD_PLACEHOLDER]: "…", // en: "Enter your password"
		// [Translations.PHONE_LABEL]: "…", // en: "Phone Number *"
		// [Translations.PHONE_PLACEHOLDER]: "…", // en: "(555) 555-1212"
		// [Translations.QR_CODE_ALT]: "…", // en: "qrcode"
		// [Translations.RESET_PASSWORD_TEXT]: "…", // en: "Reset password"
		// [Translations.RESET_YOUR_PASSWORD]: "…", // en: "Reset your password"
		// [Translations.SELECT_MFA_TYPE_HEADER_TEXT]: "…", // en: "Select MFA Type"
		// [Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify"
		// [Translations.SEND_CODE]: "…", // en: "Send Code"
		// [Translations.SUBMIT]: "…", // en: "Submit"
		// [Translations.SETUP_TOTP_REQUIRED]: "…", // en: "TOTP needs to be configured"
		// [Translations.SIGN_IN_ACTION]: "…", // en: "Sign In"
		// [Translations.SIGN_IN_HEADER_TEXT]: "…", // en: "Sign in to your account"
		// [Translations.SIGN_IN_TEXT]: "…", // en: "Sign in"
		// [Translations.SIGN_IN_WITH_AMAZON]: "…", // en: "Sign in with Amazon"
		// [Translations.SIGN_IN_WITH_AUTH0]: "…", // en: "Sign in with Auth0"
		// [Translations.SIGN_IN_WITH_AWS]: "…", // en: "Sign in with AWS"
		// [Translations.SIGN_IN_WITH_FACEBOOK]: "…", // en: "Sign in with Facebook"
		// [Translations.SIGN_IN_WITH_GOOGLE]: "…", // en: "Sign in with Google"
		// [Translations.SIGN_OUT]: "…", // en: "Sign Out"
		// [Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "…", // en: "Email"
		// [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "…", // en: "Have an account?"
		// [Translations.SIGN_UP_HEADER_TEXT]: "…", // en: "Create a new account"
		// [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "…", // en: "Password"
		// [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Create Account"
		// [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "…", // en: "Username"
		// [Translations.SUCCESS_MFA_TYPE]: "…", // en: "Success! Your MFA Type is now:"
		// [Translations.TOTP_HEADER_TEXT]: "…", // en: "Scan then enter verification code"
		// [Translations.TOTP_LABEL]: "…", // en: "Enter Security Code:"
		// [Translations.TOTP_ISSUER]: "…", // en: "AWSCognito"
		// [Translations.TOTP_SETUP_FAILURE]: "…", // en: "TOTP Setup has failed"
		// [Translations.TOTP_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify Security Token"
		// [Translations.TOTP_SUCCESS_MESSAGE]: "…", // en: "Setup TOTP successfully!"
		// [Translations.UNABLE_TO_SETUP_MFA_AT_THIS_TIME]: "…", // en: "Failed! Unable to configure MFA at this time"
		// [Translations.USERNAME_LABEL]: "…", // en: "Username *"
		// [Translations.USERNAME_PLACEHOLDER]: "…", // en: "Enter your username"
		// [Translations.VERIFY_CONTACT_EMAIL_LABEL]: "…", // en: "Email"
		// [Translations.VERIFY_CONTACT_HEADER_TEXT]: "…", // en: "Account recovery requires verified contact information"
		// [Translations.VERIFY_CONTACT_PHONE_LABEL]: "…", // en: "Phone Number"
		// [Translations.VERIFY_CONTACT_SUBMIT_LABEL]: "…", // en: "Submit"
		// [Translations.VERIFY_CONTACT_VERIFY_LABEL]: "…", // en: "Verify"
		// [Translations.ADDRESS_LABEL]: "…", // en: "Address"
		// [Translations.ADDRESS_PLACEHOLDER]: "…", // en: "Enter your address"
		// [Translations.NICKNAME_LABEL]: "…", // en: "Nickname"
		// [Translations.NICKNAME_PLACEHOLDER]: "…", // en: "Enter your nickname"
		// [Translations.BIRTHDATE_LABEL]: "…", // en: "Birthday"
		// [Translations.BIRTHDATE_PLACEHOLDER]: "…", // en: "Enter your birthday"
		// [Translations.PICTURE_LABEL]: "…", // en: "Picture URL"
		// [Translations.PICTURE_PLACEHOLDER]: "…", // en: "Enter your picture URL"
		// [Translations.FAMILY_NAME_LABEL]: "…", // en: "Family Name"
		// [Translations.FAMILY_NAME_PLACEHOLDER]: "…", // en: "Enter your family name"
		// [Translations.PREFERRED_USERNAME_LABEL]: "…", // en: "Preferred Username"
		// [Translations.PREFERRED_USERNAME_PLACEHOLDER]: "…", // en: "Enter your preferred username"
		// [Translations.GENDER_LABEL]: "…", // en: "Gender"
		// [Translations.GENDER_PLACEHOLDER]: "…", // en: "Enter your gender"
		// [Translations.PROFILE_LABEL]: "…", // en: "Profile URL"
		// [Translations.PROFILE_PLACEHOLDER]: "…", // en: "Enter your profile URL"
		// [Translations.GIVEN_NAME_LABEL]: "…", // en: "First Name"
		// [Translations.GIVEN_NAME_PLACEHOLDER]: "…", // en: "Enter your first name"
		// [Translations.ZONEINFO_LABEL]: "…", // en: "Time zone"
		// [Translations.ZONEINFO_PLACEHOLDER]: "…", // en: "Enter your time zone"
		// [Translations.LOCALE_LABEL]: "…", // en: "Locale"
		// [Translations.LOCALE_PLACEHOLDER]: "…", // en: "Enter your locale"
		// [Translations.UPDATED_AT_LABEL]: "…", // en: "Updated At"
		// [Translations.UPDATED_AT_PLACEHOLDER]: "…", // en: "Enter the time the information was last updated"
		// [Translations.MIDDLE_NAME_LABEL]: "…", // en: "Middle Name"
		// [Translations.MIDDLE_NAME_PLACEHOLDER]: "…", // en: "Enter your middle name"
		// [Translations.WEBSITE_LABEL]: "…", // en: "Website"
		// [Translations.WEBSITE_PLACEHOLDER]: "…", // en: "Enter your website"
		// [Translations.NAME_LABEL]: "…", // en: "Full Name"
		// [Translations.NAME_PLACEHOLDER]: "…", // en: "Enter your full name"
		// [Translations.PHOTO_PICKER_TITLE]: "…", // en: "Picker Title"
		// [Translations.PHOTO_PICKER_HINT]: "…", // en: "Ancillary text or content may occupy this space here"
		// [Translations.PHOTO_PICKER_PLACEHOLDER_HINT]: "…", // en: "Placeholder hint"
		// [Translations.PHOTO_PICKER_BUTTON_TEXT]: "…", // en: "Button"
		// [Translations.IMAGE_PICKER_TITLE]: "…", // en: "Add Profile Photo"
		// [Translations.IMAGE_PICKER_HINT]: "…", // en: "Preview the image before upload"
		// [Translations.IMAGE_PICKER_PLACEHOLDER_HINT]: "…", // en: "Tap to image select"
		// [Translations.IMAGE_PICKER_BUTTON_TEXT]: "…", // en: "Upload"
		// [Translations.PICKER_TEXT]: "…", // en: "Pick a file"
		// [Translations.TEXT_FALLBACK_CONTENT]: "…", // en: "Fallback Content"
		// [Translations.CONFIRM_SIGN_UP_FAILED]: "…", // en: "Confirm Sign Up Failed"
		// [Translations.SIGN_UP_FAILED]: "…", // en: "Sign Up Failed"
		// [Translations.DEFAULT_MSG]: "…", // en: "Authentication Error"
		// [Translations.EMPTY_EMAIL]: "…", // en: "Email cannot be empty"
		// [Translations.EMPTY_PHONE]: "…", // en: "Phone number cannot be empty"
		// [Translations.EMPTY_USERNAME]: "…", // en: "Username cannot be empty"
		// [Translations.INVALID_USERNAME]: "…", // en: "The username should either be a string or one of the sign in types"
		// [Translations.EMPTY_PASSWORD]: "…", // en: "Password cannot be empty"
		// [Translations.EMPTY_CODE]: "…", // en: "Confirmation code cannot be empty"
		// [Translations.SIGN_UP_ERROR]: "…", // en: "Error creating account"
		// [Translations.NO_MFA]: "…", // en: "No valid MFA method provided"
		// [Translations.INVALID_MFA]: "…", // en: "Invalid MFA type"
		// [Translations.EMPTY_CHALLENGE]: "…", // en: "Challenge response cannot be empty"
		// [Translations.NO_USER_SESSION]: "…", // en: "Failed to get the session because the user is empty"
		// [Translations.NETWORK_ERROR]: "…", // en: "Network Error"
		// [Translations.DEVICE_CONFIG]: "…", // en: "Device tracking has not been configured in this User Pool"
		// [Translations.CHATBOT_TITLE]: "…", // en: "ChatBot Lex"
		// [Translations.TEXT_INPUT_PLACEHOLDER]: "…", // en: "Write a message"
		// [Translations.VOICE_INPUT_PLACEHOLDER]: "…", // en: "Click mic to speak"
		// [Translations.CHAT_DISABLED_ERROR]: "…", // en: "Error: Either voice or text must be enabled for the chatbot"
		// [Translations.NO_BOT_NAME_ERROR]: "…", // en: "Error: Bot name must be provided to ChatBot"
	},
	it: {
		[Translations.VERIFY_CONTACT_HEADER_TEXT]:
			"Ripristino del conto richiede un account verificati",
		"An account with the given email already exists.":
			"Un account con questa email esiste già.",
		[Translations.BACK_TO_SIGN_IN]: "Torna alla Accesso",
		[Translations.CHANGE_PASSWORD]: "Cambia la password",
		Code: "Codice",
		[Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "Conferma",
		"Confirm Sign In": "Conferma di applicazione",
		"Confirm Sign Up": "Registrazione Conferma",
		"Confirm a Code": "Codice Conferma",
		[Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "Codice di verifica",
		[Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "Crea account",
		[Translations.SIGN_UP_HEADER_TEXT]: "Creare un nuovo account",
		[Translations.CREATE_ACCOUNT_TEXT]: "Registrati",
		[Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "E-mail",
		[Translations.PASSWORD_PLACEHOLDER]: "Inserire la password",
		[Translations.USERNAME_PLACEHOLDER]: "Inserisci il tuo nome utente",
		"Forget your password?": "Password dimenticata?",
		"Forgot Password": "Password dimenticata",
		"Have an account? ": "Già registrato?",
		"Incorrect username or password": "Nome utente o password errati",
		"Invalid password format": "Formato della password non valido",
		"Invalid phone number format":
			"Utilizzo non valido Telefonummern formattare un numero nel formato :. 12.345.678,9 mille",
		[Translations.CONFIRM_SIGN_UP_LOST_CODE]: "Perso codice?",
		"New Password": "Nuova password",
		"No account? ": "Nessun account?",
		[Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "Password",
		"Password attempts exceeded":
			"Il numero massimo di tentativi di accesso falliti è stato raggiunto",
		[Translations.VERIFY_CONTACT_PHONE_LABEL]: "Numero di telefono",
		[Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "Codice Rispedisci",
		[Translations.RESET_PASSWORD_TEXT]: "Ripristina password",
		[Translations.RESET_YOUR_PASSWORD]: "Resetta password",
		[Translations.SEND_CODE]: "Invia codice",
		[Translations.SIGN_IN_ACTION]: "Accesso",
		[Translations.SIGN_OUT]: "Esci",
		"Sign Up": "Iscriviti",
		[Translations.SIGN_IN_TEXT]: "Accesso",
		[Translations.SIGN_IN_HEADER_TEXT]: "Accedi con il tuo account a",
		Skip: "Salta",
		[Translations.SUBMIT]: "Sottoscrivi",
		"User already exists": "Questo utente esiste già",
		"User does not exist": "Questo utente non esiste",
		[Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "Nome utente",
		[Translations.EMPTY_USERNAME]: "Nome utente non può essere vuoto",
		[Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "Verifica",
		"Verify Contact": "Contatto verifica",
		// Undefined Translations
		// [Translations.BACK_TO_SIGN_IN]: "…", // en: "Back to Sign In"
		// [Translations.CHANGE_PASSWORD_ACTION]: "…", // en: "Change"
		// [Translations.CHANGE_PASSWORD]: "…", // en: "Change Password"
		// [Translations.CODE_LABEL]: "…", // en: "Verification code"
		// [Translations.CODE_PLACEHOLDER]: "…", // en: "Enter code"
		// [Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "…", // en: "Confirmation Code"
		// [Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]: "…", // en: "Enter your code"
		// [Translations.CONFIRM_SIGN_UP_HEADER_TEXT]: "…", // en: "Confirm Sign up"
		// [Translations.CONFIRM_SIGN_UP_LOST_CODE]: "…", // en: "Lost your code?"
		// [Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "…", // en: "Resend Code"
		// [Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Confirm"
		// [Translations.CONFIRM_SMS_CODE]: "…", // en: "Confirm SMS Code"
		// [Translations.CONFIRM_TOTP_CODE]: "…", // en: "Confirm TOTP Code"
		// [Translations.CONFIRM]: "…", // en: "Confirm"
		// [Translations.CREATE_ACCOUNT_TEXT]: "…", // en: "Create account"
		// [Translations.EMAIL_LABEL]: "…", // en: "Email Address *"
		// [Translations.EMAIL_PLACEHOLDER]: "…", // en: "Enter your email address"
		// [Translations.FORGOT_PASSWORD_TEXT]: "…", // en: "Forgot your password?"
		// [Translations.LESS_THAN_TWO_MFA_VALUES_MESSAGE]: "…", // en: "Less than two MFA types available"
		// [Translations.NEW_PASSWORD_LABEL]: "…", // en: "New password"
		// [Translations.NEW_PASSWORD_PLACEHOLDER]: "…", // en: "Enter your new password"
		// [Translations.NO_ACCOUNT_TEXT]: "…", // en: "No account?"
		// [Translations.USERNAME_REMOVE_WHITESPACE]: "…", // en: "Username cannot contain whitespace"
		// [Translations.PASSWORD_REMOVE_WHITESPACE]: "…", // en: "Password cannot start or end with whitespace"
		// [Translations.PASSWORD_LABEL]: "…", // en: "Password *"
		// [Translations.PASSWORD_PLACEHOLDER]: "…", // en: "Enter your password"
		// [Translations.PHONE_LABEL]: "…", // en: "Phone Number *"
		// [Translations.PHONE_PLACEHOLDER]: "…", // en: "(555) 555-1212"
		// [Translations.QR_CODE_ALT]: "…", // en: "qrcode"
		// [Translations.RESET_PASSWORD_TEXT]: "…", // en: "Reset password"
		// [Translations.RESET_YOUR_PASSWORD]: "…", // en: "Reset your password"
		// [Translations.SELECT_MFA_TYPE_HEADER_TEXT]: "…", // en: "Select MFA Type"
		// [Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify"
		// [Translations.SEND_CODE]: "…", // en: "Send Code"
		// [Translations.SUBMIT]: "…", // en: "Submit"
		// [Translations.SETUP_TOTP_REQUIRED]: "…", // en: "TOTP needs to be configured"
		// [Translations.SIGN_IN_ACTION]: "…", // en: "Sign In"
		// [Translations.SIGN_IN_HEADER_TEXT]: "…", // en: "Sign in to your account"
		// [Translations.SIGN_IN_TEXT]: "…", // en: "Sign in"
		// [Translations.SIGN_IN_WITH_AMAZON]: "…", // en: "Sign in with Amazon"
		// [Translations.SIGN_IN_WITH_AUTH0]: "…", // en: "Sign in with Auth0"
		// [Translations.SIGN_IN_WITH_AWS]: "…", // en: "Sign in with AWS"
		// [Translations.SIGN_IN_WITH_FACEBOOK]: "…", // en: "Sign in with Facebook"
		// [Translations.SIGN_IN_WITH_GOOGLE]: "…", // en: "Sign in with Google"
		// [Translations.SIGN_OUT]: "…", // en: "Sign Out"
		// [Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "…", // en: "Email"
		// [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "…", // en: "Have an account?"
		// [Translations.SIGN_UP_HEADER_TEXT]: "…", // en: "Create a new account"
		// [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "…", // en: "Password"
		// [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Create Account"
		// [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "…", // en: "Username"
		// [Translations.SUCCESS_MFA_TYPE]: "…", // en: "Success! Your MFA Type is now:"
		// [Translations.TOTP_HEADER_TEXT]: "…", // en: "Scan then enter verification code"
		// [Translations.TOTP_LABEL]: "…", // en: "Enter Security Code:"
		// [Translations.TOTP_ISSUER]: "…", // en: "AWSCognito"
		// [Translations.TOTP_SETUP_FAILURE]: "…", // en: "TOTP Setup has failed"
		// [Translations.TOTP_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify Security Token"
		// [Translations.TOTP_SUCCESS_MESSAGE]: "…", // en: "Setup TOTP successfully!"
		// [Translations.UNABLE_TO_SETUP_MFA_AT_THIS_TIME]: "…", // en: "Failed! Unable to configure MFA at this time"
		// [Translations.USERNAME_LABEL]: "…", // en: "Username *"
		// [Translations.USERNAME_PLACEHOLDER]: "…", // en: "Enter your username"
		// [Translations.VERIFY_CONTACT_EMAIL_LABEL]: "…", // en: "Email"
		// [Translations.VERIFY_CONTACT_HEADER_TEXT]: "…", // en: "Account recovery requires verified contact information"
		// [Translations.VERIFY_CONTACT_PHONE_LABEL]: "…", // en: "Phone Number"
		// [Translations.VERIFY_CONTACT_SUBMIT_LABEL]: "…", // en: "Submit"
		// [Translations.VERIFY_CONTACT_VERIFY_LABEL]: "…", // en: "Verify"
		// [Translations.ADDRESS_LABEL]: "…", // en: "Address"
		// [Translations.ADDRESS_PLACEHOLDER]: "…", // en: "Enter your address"
		// [Translations.NICKNAME_LABEL]: "…", // en: "Nickname"
		// [Translations.NICKNAME_PLACEHOLDER]: "…", // en: "Enter your nickname"
		// [Translations.BIRTHDATE_LABEL]: "…", // en: "Birthday"
		// [Translations.BIRTHDATE_PLACEHOLDER]: "…", // en: "Enter your birthday"
		// [Translations.PICTURE_LABEL]: "…", // en: "Picture URL"
		// [Translations.PICTURE_PLACEHOLDER]: "…", // en: "Enter your picture URL"
		// [Translations.FAMILY_NAME_LABEL]: "…", // en: "Family Name"
		// [Translations.FAMILY_NAME_PLACEHOLDER]: "…", // en: "Enter your family name"
		// [Translations.PREFERRED_USERNAME_LABEL]: "…", // en: "Preferred Username"
		// [Translations.PREFERRED_USERNAME_PLACEHOLDER]: "…", // en: "Enter your preferred username"
		// [Translations.GENDER_LABEL]: "…", // en: "Gender"
		// [Translations.GENDER_PLACEHOLDER]: "…", // en: "Enter your gender"
		// [Translations.PROFILE_LABEL]: "…", // en: "Profile URL"
		// [Translations.PROFILE_PLACEHOLDER]: "…", // en: "Enter your profile URL"
		// [Translations.GIVEN_NAME_LABEL]: "…", // en: "First Name"
		// [Translations.GIVEN_NAME_PLACEHOLDER]: "…", // en: "Enter your first name"
		// [Translations.ZONEINFO_LABEL]: "…", // en: "Time zone"
		// [Translations.ZONEINFO_PLACEHOLDER]: "…", // en: "Enter your time zone"
		// [Translations.LOCALE_LABEL]: "…", // en: "Locale"
		// [Translations.LOCALE_PLACEHOLDER]: "…", // en: "Enter your locale"
		// [Translations.UPDATED_AT_LABEL]: "…", // en: "Updated At"
		// [Translations.UPDATED_AT_PLACEHOLDER]: "…", // en: "Enter the time the information was last updated"
		// [Translations.MIDDLE_NAME_LABEL]: "…", // en: "Middle Name"
		// [Translations.MIDDLE_NAME_PLACEHOLDER]: "…", // en: "Enter your middle name"
		// [Translations.WEBSITE_LABEL]: "…", // en: "Website"
		// [Translations.WEBSITE_PLACEHOLDER]: "…", // en: "Enter your website"
		// [Translations.NAME_LABEL]: "…", // en: "Full Name"
		// [Translations.NAME_PLACEHOLDER]: "…", // en: "Enter your full name"
		// [Translations.PHOTO_PICKER_TITLE]: "…", // en: "Picker Title"
		// [Translations.PHOTO_PICKER_HINT]: "…", // en: "Ancillary text or content may occupy this space here"
		// [Translations.PHOTO_PICKER_PLACEHOLDER_HINT]: "…", // en: "Placeholder hint"
		// [Translations.PHOTO_PICKER_BUTTON_TEXT]: "…", // en: "Button"
		// [Translations.IMAGE_PICKER_TITLE]: "…", // en: "Add Profile Photo"
		// [Translations.IMAGE_PICKER_HINT]: "…", // en: "Preview the image before upload"
		// [Translations.IMAGE_PICKER_PLACEHOLDER_HINT]: "…", // en: "Tap to image select"
		// [Translations.IMAGE_PICKER_BUTTON_TEXT]: "…", // en: "Upload"
		// [Translations.PICKER_TEXT]: "…", // en: "Pick a file"
		// [Translations.TEXT_FALLBACK_CONTENT]: "…", // en: "Fallback Content"
		// [Translations.CONFIRM_SIGN_UP_FAILED]: "…", // en: "Confirm Sign Up Failed"
		// [Translations.SIGN_UP_FAILED]: "…", // en: "Sign Up Failed"
		// [Translations.DEFAULT_MSG]: "…", // en: "Authentication Error"
		// [Translations.EMPTY_EMAIL]: "…", // en: "Email cannot be empty"
		// [Translations.EMPTY_PHONE]: "…", // en: "Phone number cannot be empty"
		// [Translations.EMPTY_USERNAME]: "…", // en: "Username cannot be empty"
		// [Translations.INVALID_USERNAME]: "…", // en: "The username should either be a string or one of the sign in types"
		// [Translations.EMPTY_PASSWORD]: "…", // en: "Password cannot be empty"
		// [Translations.EMPTY_CODE]: "…", // en: "Confirmation code cannot be empty"
		// [Translations.SIGN_UP_ERROR]: "…", // en: "Error creating account"
		// [Translations.NO_MFA]: "…", // en: "No valid MFA method provided"
		// [Translations.INVALID_MFA]: "…", // en: "Invalid MFA type"
		// [Translations.EMPTY_CHALLENGE]: "…", // en: "Challenge response cannot be empty"
		// [Translations.NO_USER_SESSION]: "…", // en: "Failed to get the session because the user is empty"
		// [Translations.NETWORK_ERROR]: "…", // en: "Network Error"
		// [Translations.DEVICE_CONFIG]: "…", // en: "Device tracking has not been configured in this User Pool"
		// [Translations.CHATBOT_TITLE]: "…", // en: "ChatBot Lex"
		// [Translations.TEXT_INPUT_PLACEHOLDER]: "…", // en: "Write a message"
		// [Translations.VOICE_INPUT_PLACEHOLDER]: "…", // en: "Click mic to speak"
		// [Translations.CHAT_DISABLED_ERROR]: "…", // en: "Error: Either voice or text must be enabled for the chatbot"
		// [Translations.NO_BOT_NAME_ERROR]: "…", // en: "Error: Bot name must be provided to ChatBot"
	},
	zh: {
		[Translations.SIGN_IN_ACTION]: "登录",
		"Sign Up": "注册",
		[Translations.SIGN_OUT]: "退出",
		"Forgot Password": "忘记密码",
		[Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "用户名",
		[Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "密码",
		[Translations.CHANGE_PASSWORD]: "改变密码",
		"New Password": "新密码",
		[Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "邮箱",
		[Translations.VERIFY_CONTACT_PHONE_LABEL]: "电话",
		"Confirm a Code": "确认码",
		"Confirm Sign In": "确认登录",
		"Confirm Sign Up": "确认注册",
		[Translations.BACK_TO_SIGN_IN]: "回到登录",
		[Translations.SEND_CODE]: "发送确认码",
		[Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "确认",
		"Resend a Code": "重发确认码",
		[Translations.SUBMIT]: "提交",
		Skip: "跳过",
		[Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "验证",
		"Verify Contact": "验证联系方式",
		Code: "确认码",
		[Translations.VERIFY_CONTACT_HEADER_TEXT]: "账户恢复需要验证过的联系方式",
		"User does not exist": "用户不存在",
		"User already exists": "用户已经存在",
		"Incorrect username or password": "用户名或密码错误",
		"Invalid password format": "密码格式错误",
		"Invalid phone number format": "电话格式错误，请使用格式 +12345678900",
		// Undefined Translations
		// [Translations.BACK_TO_SIGN_IN]: "…", // en: "Back to Sign In"
		// [Translations.CHANGE_PASSWORD_ACTION]: "…", // en: "Change"
		// [Translations.CHANGE_PASSWORD]: "…", // en: "Change Password"
		// [Translations.CODE_LABEL]: "…", // en: "Verification code"
		// [Translations.CODE_PLACEHOLDER]: "…", // en: "Enter code"
		// [Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "…", // en: "Confirmation Code"
		// [Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]: "…", // en: "Enter your code"
		// [Translations.CONFIRM_SIGN_UP_HEADER_TEXT]: "…", // en: "Confirm Sign up"
		// [Translations.CONFIRM_SIGN_UP_LOST_CODE]: "…", // en: "Lost your code?"
		// [Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "…", // en: "Resend Code"
		// [Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Confirm"
		// [Translations.CONFIRM_SMS_CODE]: "…", // en: "Confirm SMS Code"
		// [Translations.CONFIRM_TOTP_CODE]: "…", // en: "Confirm TOTP Code"
		// [Translations.CONFIRM]: "…", // en: "Confirm"
		// [Translations.CREATE_ACCOUNT_TEXT]: "…", // en: "Create account"
		// [Translations.EMAIL_LABEL]: "…", // en: "Email Address *"
		// [Translations.EMAIL_PLACEHOLDER]: "…", // en: "Enter your email address"
		// [Translations.FORGOT_PASSWORD_TEXT]: "…", // en: "Forgot your password?"
		// [Translations.LESS_THAN_TWO_MFA_VALUES_MESSAGE]: "…", // en: "Less than two MFA types available"
		// [Translations.NEW_PASSWORD_LABEL]: "…", // en: "New password"
		// [Translations.NEW_PASSWORD_PLACEHOLDER]: "…", // en: "Enter your new password"
		// [Translations.NO_ACCOUNT_TEXT]: "…", // en: "No account?"
		// [Translations.USERNAME_REMOVE_WHITESPACE]: "…", // en: "Username cannot contain whitespace"
		// [Translations.PASSWORD_REMOVE_WHITESPACE]: "…", // en: "Password cannot start or end with whitespace"
		// [Translations.PASSWORD_LABEL]: "…", // en: "Password *"
		// [Translations.PASSWORD_PLACEHOLDER]: "…", // en: "Enter your password"
		// [Translations.PHONE_LABEL]: "…", // en: "Phone Number *"
		// [Translations.PHONE_PLACEHOLDER]: "…", // en: "(555) 555-1212"
		// [Translations.QR_CODE_ALT]: "…", // en: "qrcode"
		// [Translations.RESET_PASSWORD_TEXT]: "…", // en: "Reset password"
		// [Translations.RESET_YOUR_PASSWORD]: "…", // en: "Reset your password"
		// [Translations.SELECT_MFA_TYPE_HEADER_TEXT]: "…", // en: "Select MFA Type"
		// [Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify"
		// [Translations.SEND_CODE]: "…", // en: "Send Code"
		// [Translations.SUBMIT]: "…", // en: "Submit"
		// [Translations.SETUP_TOTP_REQUIRED]: "…", // en: "TOTP needs to be configured"
		// [Translations.SIGN_IN_ACTION]: "…", // en: "Sign In"
		// [Translations.SIGN_IN_HEADER_TEXT]: "…", // en: "Sign in to your account"
		// [Translations.SIGN_IN_TEXT]: "…", // en: "Sign in"
		// [Translations.SIGN_IN_WITH_AMAZON]: "…", // en: "Sign in with Amazon"
		// [Translations.SIGN_IN_WITH_AUTH0]: "…", // en: "Sign in with Auth0"
		// [Translations.SIGN_IN_WITH_AWS]: "…", // en: "Sign in with AWS"
		// [Translations.SIGN_IN_WITH_FACEBOOK]: "…", // en: "Sign in with Facebook"
		// [Translations.SIGN_IN_WITH_GOOGLE]: "…", // en: "Sign in with Google"
		// [Translations.SIGN_OUT]: "…", // en: "Sign Out"
		// [Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "…", // en: "Email"
		// [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "…", // en: "Have an account?"
		// [Translations.SIGN_UP_HEADER_TEXT]: "…", // en: "Create a new account"
		// [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "…", // en: "Password"
		// [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Create Account"
		// [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "…", // en: "Username"
		// [Translations.SUCCESS_MFA_TYPE]: "…", // en: "Success! Your MFA Type is now:"
		// [Translations.TOTP_HEADER_TEXT]: "…", // en: "Scan then enter verification code"
		// [Translations.TOTP_LABEL]: "…", // en: "Enter Security Code:"
		// [Translations.TOTP_ISSUER]: "…", // en: "AWSCognito"
		// [Translations.TOTP_SETUP_FAILURE]: "…", // en: "TOTP Setup has failed"
		// [Translations.TOTP_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify Security Token"
		// [Translations.TOTP_SUCCESS_MESSAGE]: "…", // en: "Setup TOTP successfully!"
		// [Translations.UNABLE_TO_SETUP_MFA_AT_THIS_TIME]: "…", // en: "Failed! Unable to configure MFA at this time"
		// [Translations.USERNAME_LABEL]: "…", // en: "Username *"
		// [Translations.USERNAME_PLACEHOLDER]: "…", // en: "Enter your username"
		// [Translations.VERIFY_CONTACT_EMAIL_LABEL]: "…", // en: "Email"
		// [Translations.VERIFY_CONTACT_HEADER_TEXT]: "…", // en: "Account recovery requires verified contact information"
		// [Translations.VERIFY_CONTACT_PHONE_LABEL]: "…", // en: "Phone Number"
		// [Translations.VERIFY_CONTACT_SUBMIT_LABEL]: "…", // en: "Submit"
		// [Translations.VERIFY_CONTACT_VERIFY_LABEL]: "…", // en: "Verify"
		// [Translations.ADDRESS_LABEL]: "…", // en: "Address"
		// [Translations.ADDRESS_PLACEHOLDER]: "…", // en: "Enter your address"
		// [Translations.NICKNAME_LABEL]: "…", // en: "Nickname"
		// [Translations.NICKNAME_PLACEHOLDER]: "…", // en: "Enter your nickname"
		// [Translations.BIRTHDATE_LABEL]: "…", // en: "Birthday"
		// [Translations.BIRTHDATE_PLACEHOLDER]: "…", // en: "Enter your birthday"
		// [Translations.PICTURE_LABEL]: "…", // en: "Picture URL"
		// [Translations.PICTURE_PLACEHOLDER]: "…", // en: "Enter your picture URL"
		// [Translations.FAMILY_NAME_LABEL]: "…", // en: "Family Name"
		// [Translations.FAMILY_NAME_PLACEHOLDER]: "…", // en: "Enter your family name"
		// [Translations.PREFERRED_USERNAME_LABEL]: "…", // en: "Preferred Username"
		// [Translations.PREFERRED_USERNAME_PLACEHOLDER]: "…", // en: "Enter your preferred username"
		// [Translations.GENDER_LABEL]: "…", // en: "Gender"
		// [Translations.GENDER_PLACEHOLDER]: "…", // en: "Enter your gender"
		// [Translations.PROFILE_LABEL]: "…", // en: "Profile URL"
		// [Translations.PROFILE_PLACEHOLDER]: "…", // en: "Enter your profile URL"
		// [Translations.GIVEN_NAME_LABEL]: "…", // en: "First Name"
		// [Translations.GIVEN_NAME_PLACEHOLDER]: "…", // en: "Enter your first name"
		// [Translations.ZONEINFO_LABEL]: "…", // en: "Time zone"
		// [Translations.ZONEINFO_PLACEHOLDER]: "…", // en: "Enter your time zone"
		// [Translations.LOCALE_LABEL]: "…", // en: "Locale"
		// [Translations.LOCALE_PLACEHOLDER]: "…", // en: "Enter your locale"
		// [Translations.UPDATED_AT_LABEL]: "…", // en: "Updated At"
		// [Translations.UPDATED_AT_PLACEHOLDER]: "…", // en: "Enter the time the information was last updated"
		// [Translations.MIDDLE_NAME_LABEL]: "…", // en: "Middle Name"
		// [Translations.MIDDLE_NAME_PLACEHOLDER]: "…", // en: "Enter your middle name"
		// [Translations.WEBSITE_LABEL]: "…", // en: "Website"
		// [Translations.WEBSITE_PLACEHOLDER]: "…", // en: "Enter your website"
		// [Translations.NAME_LABEL]: "…", // en: "Full Name"
		// [Translations.NAME_PLACEHOLDER]: "…", // en: "Enter your full name"
		// [Translations.PHOTO_PICKER_TITLE]: "…", // en: "Picker Title"
		// [Translations.PHOTO_PICKER_HINT]: "…", // en: "Ancillary text or content may occupy this space here"
		// [Translations.PHOTO_PICKER_PLACEHOLDER_HINT]: "…", // en: "Placeholder hint"
		// [Translations.PHOTO_PICKER_BUTTON_TEXT]: "…", // en: "Button"
		// [Translations.IMAGE_PICKER_TITLE]: "…", // en: "Add Profile Photo"
		// [Translations.IMAGE_PICKER_HINT]: "…", // en: "Preview the image before upload"
		// [Translations.IMAGE_PICKER_PLACEHOLDER_HINT]: "…", // en: "Tap to image select"
		// [Translations.IMAGE_PICKER_BUTTON_TEXT]: "…", // en: "Upload"
		// [Translations.PICKER_TEXT]: "…", // en: "Pick a file"
		// [Translations.TEXT_FALLBACK_CONTENT]: "…", // en: "Fallback Content"
		// [Translations.CONFIRM_SIGN_UP_FAILED]: "…", // en: "Confirm Sign Up Failed"
		// [Translations.SIGN_UP_FAILED]: "…", // en: "Sign Up Failed"
		// [Translations.DEFAULT_MSG]: "…", // en: "Authentication Error"
		// [Translations.EMPTY_EMAIL]: "…", // en: "Email cannot be empty"
		// [Translations.EMPTY_PHONE]: "…", // en: "Phone number cannot be empty"
		// [Translations.EMPTY_USERNAME]: "…", // en: "Username cannot be empty"
		// [Translations.INVALID_USERNAME]: "…", // en: "The username should either be a string or one of the sign in types"
		// [Translations.EMPTY_PASSWORD]: "…", // en: "Password cannot be empty"
		// [Translations.EMPTY_CODE]: "…", // en: "Confirmation code cannot be empty"
		// [Translations.SIGN_UP_ERROR]: "…", // en: "Error creating account"
		// [Translations.NO_MFA]: "…", // en: "No valid MFA method provided"
		// [Translations.INVALID_MFA]: "…", // en: "Invalid MFA type"
		// [Translations.EMPTY_CHALLENGE]: "…", // en: "Challenge response cannot be empty"
		// [Translations.NO_USER_SESSION]: "…", // en: "Failed to get the session because the user is empty"
		// [Translations.NETWORK_ERROR]: "…", // en: "Network Error"
		// [Translations.DEVICE_CONFIG]: "…", // en: "Device tracking has not been configured in this User Pool"
		// [Translations.CHATBOT_TITLE]: "…", // en: "ChatBot Lex"
		// [Translations.TEXT_INPUT_PLACEHOLDER]: "…", // en: "Write a message"
		// [Translations.VOICE_INPUT_PLACEHOLDER]: "…", // en: "Click mic to speak"
		// [Translations.CHAT_DISABLED_ERROR]: "…", // en: "Error: Either voice or text must be enabled for the chatbot"
		// [Translations.NO_BOT_NAME_ERROR]: "…", // en: "Error: Bot name must be provided to ChatBot"
	},
	ja: {
		[Translations.SIGN_IN_ACTION]: "サインイン ",
		"Sign Up": "登録 ",
		[Translations.SIGN_OUT]: "サインアウト ",
		[Translations.SIGN_IN_HEADER_TEXT]: "アカウントにサインイン ",
		[Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "ユーザー名 ",
		[Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "パスワード ",
		[Translations.USERNAME_PLACEHOLDER]: "ユーザー名を入力 ",
		[Translations.PASSWORD_PLACEHOLDER]: "パスワードを入力 ",
		"No account? ": "アカウントが無いとき ",
		"Forget your password? ": "パスワードを忘れましたか？ ",
		[Translations.RESET_PASSWORD_TEXT]: "パスワードをリセット ",
		"User does not exist": "ユーザーが存在しません ",
		"User already exists": "既にユーザーが存在しています ",
		"Incorrect username or password": "ユーザー名かパスワードが異なります ",
		"Invalid password format": "パスワードの形式が無効です ",
		[Translations.CREATE_ACCOUNT_TEXT]: "アカウントを作る ",
		"Forgot Password": "パスワードを忘れた ",
		[Translations.CHANGE_PASSWORD]: "パスワードを変える ",
		"New Password": "新しいパスワード",
		[Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "メールアドレス",
		[Translations.VERIFY_CONTACT_PHONE_LABEL]: "電話番号",
		"Confirm a Code": "コードを確認",
		"Confirm Sign In": "サインインする",
		"Confirm Sign Up": "登録する",
		[Translations.BACK_TO_SIGN_IN]: "サインインに戻る",
		[Translations.SEND_CODE]: "コードを送信",
		[Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "確定",
		[Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "コードを再送信",
		[Translations.SUBMIT]: "送信",
		Skip: "スキップ",
		[Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "確認",
		"Verify Contact": "連絡先を確認",
		Code: "コード",
		[Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "確認コード",
		"Lost your code? ": "コードを失くしましたか？",
		[Translations.VERIFY_CONTACT_HEADER_TEXT]:
			"アカウントの復旧には確認済みの連絡先が必要です",
		"Invalid phone number format":
			"不正な電話番号の形式です。+12345678900 の形式で入力してください",
		[Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "アカウントを作る",
		"Have an account? ": "アカウントを持っていますか？",
		[Translations.SIGN_IN_TEXT]: "サインイン",
		[Translations.SIGN_UP_HEADER_TEXT]: "新しいアカウントを作る",
		[Translations.RESET_YOUR_PASSWORD]: "パスワードをリセットする",
		"An account with the given email already exists.":
			"入力されたメールアドレスのアカウントが既に存在します",
		[Translations.EMPTY_USERNAME]: "ユーザー名は入力必須です",
		"Password attempts exceeded": "サインインの試行回数が上限に達しました",
		"Sign In with Google": "Googleでサインイン",
		"Sign In with Facebook": "Facebookでサインイン",
		// Undefined Translations
		// [Translations.BACK_TO_SIGN_IN]: "…", // en: "Back to Sign In"
		// [Translations.CHANGE_PASSWORD_ACTION]: "…", // en: "Change"
		// [Translations.CHANGE_PASSWORD]: "…", // en: "Change Password"
		// [Translations.CODE_LABEL]: "…", // en: "Verification code"
		// [Translations.CODE_PLACEHOLDER]: "…", // en: "Enter code"
		// [Translations.CONFIRM_SIGN_UP_CODE_LABEL]: "…", // en: "Confirmation Code"
		// [Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]: "…", // en: "Enter your code"
		// [Translations.CONFIRM_SIGN_UP_HEADER_TEXT]: "…", // en: "Confirm Sign up"
		// [Translations.CONFIRM_SIGN_UP_LOST_CODE]: "…", // en: "Lost your code?"
		// [Translations.CONFIRM_SIGN_UP_RESEND_CODE]: "…", // en: "Resend Code"
		// [Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Confirm"
		// [Translations.CONFIRM_SMS_CODE]: "…", // en: "Confirm SMS Code"
		// [Translations.CONFIRM_TOTP_CODE]: "…", // en: "Confirm TOTP Code"
		// [Translations.CONFIRM]: "…", // en: "Confirm"
		// [Translations.CREATE_ACCOUNT_TEXT]: "…", // en: "Create account"
		// [Translations.EMAIL_LABEL]: "…", // en: "Email Address *"
		// [Translations.EMAIL_PLACEHOLDER]: "…", // en: "Enter your email address"
		// [Translations.FORGOT_PASSWORD_TEXT]: "…", // en: "Forgot your password?"
		// [Translations.LESS_THAN_TWO_MFA_VALUES_MESSAGE]: "…", // en: "Less than two MFA types available"
		// [Translations.NEW_PASSWORD_LABEL]: "…", // en: "New password"
		// [Translations.NEW_PASSWORD_PLACEHOLDER]: "…", // en: "Enter your new password"
		// [Translations.NO_ACCOUNT_TEXT]: "…", // en: "No account?"
		// [Translations.USERNAME_REMOVE_WHITESPACE]: "…", // en: "Username cannot contain whitespace"
		// [Translations.PASSWORD_REMOVE_WHITESPACE]: "…", // en: "Password cannot start or end with whitespace"
		// [Translations.PASSWORD_LABEL]: "…", // en: "Password *"
		// [Translations.PASSWORD_PLACEHOLDER]: "…", // en: "Enter your password"
		// [Translations.PHONE_LABEL]: "…", // en: "Phone Number *"
		// [Translations.PHONE_PLACEHOLDER]: "…", // en: "(555) 555-1212"
		// [Translations.QR_CODE_ALT]: "…", // en: "qrcode"
		// [Translations.RESET_PASSWORD_TEXT]: "…", // en: "Reset password"
		// [Translations.RESET_YOUR_PASSWORD]: "…", // en: "Reset your password"
		// [Translations.SELECT_MFA_TYPE_HEADER_TEXT]: "…", // en: "Select MFA Type"
		// [Translations.SELECT_MFA_TYPE_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify"
		// [Translations.SEND_CODE]: "…", // en: "Send Code"
		// [Translations.SUBMIT]: "…", // en: "Submit"
		// [Translations.SETUP_TOTP_REQUIRED]: "…", // en: "TOTP needs to be configured"
		// [Translations.SIGN_IN_ACTION]: "…", // en: "Sign In"
		// [Translations.SIGN_IN_HEADER_TEXT]: "…", // en: "Sign in to your account"
		// [Translations.SIGN_IN_TEXT]: "…", // en: "Sign in"
		// [Translations.SIGN_IN_WITH_AMAZON]: "…", // en: "Sign in with Amazon"
		// [Translations.SIGN_IN_WITH_AUTH0]: "…", // en: "Sign in with Auth0"
		// [Translations.SIGN_IN_WITH_AWS]: "…", // en: "Sign in with AWS"
		// [Translations.SIGN_IN_WITH_FACEBOOK]: "…", // en: "Sign in with Facebook"
		// [Translations.SIGN_IN_WITH_GOOGLE]: "…", // en: "Sign in with Google"
		// [Translations.SIGN_OUT]: "…", // en: "Sign Out"
		// [Translations.SIGN_UP_EMAIL_PLACEHOLDER]: "…", // en: "Email"
		// [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "…", // en: "Have an account?"
		// [Translations.SIGN_UP_HEADER_TEXT]: "…", // en: "Create a new account"
		// [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: "…", // en: "Password"
		// [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "…", // en: "Create Account"
		// [Translations.SIGN_UP_USERNAME_PLACEHOLDER]: "…", // en: "Username"
		// [Translations.SUCCESS_MFA_TYPE]: "…", // en: "Success! Your MFA Type is now:"
		// [Translations.TOTP_HEADER_TEXT]: "…", // en: "Scan then enter verification code"
		// [Translations.TOTP_LABEL]: "…", // en: "Enter Security Code:"
		// [Translations.TOTP_ISSUER]: "…", // en: "AWSCognito"
		// [Translations.TOTP_SETUP_FAILURE]: "…", // en: "TOTP Setup has failed"
		// [Translations.TOTP_SUBMIT_BUTTON_TEXT]: "…", // en: "Verify Security Token"
		// [Translations.TOTP_SUCCESS_MESSAGE]: "…", // en: "Setup TOTP successfully!"
		// [Translations.UNABLE_TO_SETUP_MFA_AT_THIS_TIME]: "…", // en: "Failed! Unable to configure MFA at this time"
		// [Translations.USERNAME_LABEL]: "…", // en: "Username *"
		// [Translations.USERNAME_PLACEHOLDER]: "…", // en: "Enter your username"
		// [Translations.VERIFY_CONTACT_EMAIL_LABEL]: "…", // en: "Email"
		// [Translations.VERIFY_CONTACT_HEADER_TEXT]: "…", // en: "Account recovery requires verified contact information"
		// [Translations.VERIFY_CONTACT_PHONE_LABEL]: "…", // en: "Phone Number"
		// [Translations.VERIFY_CONTACT_SUBMIT_LABEL]: "…", // en: "Submit"
		// [Translations.VERIFY_CONTACT_VERIFY_LABEL]: "…", // en: "Verify"
		// [Translations.ADDRESS_LABEL]: "…", // en: "Address"
		// [Translations.ADDRESS_PLACEHOLDER]: "…", // en: "Enter your address"
		// [Translations.NICKNAME_LABEL]: "…", // en: "Nickname"
		// [Translations.NICKNAME_PLACEHOLDER]: "…", // en: "Enter your nickname"
		// [Translations.BIRTHDATE_LABEL]: "…", // en: "Birthday"
		// [Translations.BIRTHDATE_PLACEHOLDER]: "…", // en: "Enter your birthday"
		// [Translations.PICTURE_LABEL]: "…", // en: "Picture URL"
		// [Translations.PICTURE_PLACEHOLDER]: "…", // en: "Enter your picture URL"
		// [Translations.FAMILY_NAME_LABEL]: "…", // en: "Family Name"
		// [Translations.FAMILY_NAME_PLACEHOLDER]: "…", // en: "Enter your family name"
		// [Translations.PREFERRED_USERNAME_LABEL]: "…", // en: "Preferred Username"
		// [Translations.PREFERRED_USERNAME_PLACEHOLDER]: "…", // en: "Enter your preferred username"
		// [Translations.GENDER_LABEL]: "…", // en: "Gender"
		// [Translations.GENDER_PLACEHOLDER]: "…", // en: "Enter your gender"
		// [Translations.PROFILE_LABEL]: "…", // en: "Profile URL"
		// [Translations.PROFILE_PLACEHOLDER]: "…", // en: "Enter your profile URL"
		// [Translations.GIVEN_NAME_LABEL]: "…", // en: "First Name"
		// [Translations.GIVEN_NAME_PLACEHOLDER]: "…", // en: "Enter your first name"
		// [Translations.ZONEINFO_LABEL]: "…", // en: "Time zone"
		// [Translations.ZONEINFO_PLACEHOLDER]: "…", // en: "Enter your time zone"
		// [Translations.LOCALE_LABEL]: "…", // en: "Locale"
		// [Translations.LOCALE_PLACEHOLDER]: "…", // en: "Enter your locale"
		// [Translations.UPDATED_AT_LABEL]: "…", // en: "Updated At"
		// [Translations.UPDATED_AT_PLACEHOLDER]: "…", // en: "Enter the time the information was last updated"
		// [Translations.MIDDLE_NAME_LABEL]: "…", // en: "Middle Name"
		// [Translations.MIDDLE_NAME_PLACEHOLDER]: "…", // en: "Enter your middle name"
		// [Translations.WEBSITE_LABEL]: "…", // en: "Website"
		// [Translations.WEBSITE_PLACEHOLDER]: "…", // en: "Enter your website"
		// [Translations.NAME_LABEL]: "…", // en: "Full Name"
		// [Translations.NAME_PLACEHOLDER]: "…", // en: "Enter your full name"
		// [Translations.PHOTO_PICKER_TITLE]: "…", // en: "Picker Title"
		// [Translations.PHOTO_PICKER_HINT]: "…", // en: "Ancillary text or content may occupy this space here"
		// [Translations.PHOTO_PICKER_PLACEHOLDER_HINT]: "…", // en: "Placeholder hint"
		// [Translations.PHOTO_PICKER_BUTTON_TEXT]: "…", // en: "Button"
		// [Translations.IMAGE_PICKER_TITLE]: "…", // en: "Add Profile Photo"
		// [Translations.IMAGE_PICKER_HINT]: "…", // en: "Preview the image before upload"
		// [Translations.IMAGE_PICKER_PLACEHOLDER_HINT]: "…", // en: "Tap to image select"
		// [Translations.IMAGE_PICKER_BUTTON_TEXT]: "…", // en: "Upload"
		// [Translations.PICKER_TEXT]: "…", // en: "Pick a file"
		// [Translations.TEXT_FALLBACK_CONTENT]: "…", // en: "Fallback Content"
		// [Translations.CONFIRM_SIGN_UP_FAILED]: "…", // en: "Confirm Sign Up Failed"
		// [Translations.SIGN_UP_FAILED]: "…", // en: "Sign Up Failed"
		// [Translations.DEFAULT_MSG]: "…", // en: "Authentication Error"
		// [Translations.EMPTY_EMAIL]: "…", // en: "Email cannot be empty"
		// [Translations.EMPTY_PHONE]: "…", // en: "Phone number cannot be empty"
		// [Translations.EMPTY_USERNAME]: "…", // en: "Username cannot be empty"
		// [Translations.INVALID_USERNAME]: "…", // en: "The username should either be a string or one of the sign in types"
		// [Translations.EMPTY_PASSWORD]: "…", // en: "Password cannot be empty"
		// [Translations.EMPTY_CODE]: "…", // en: "Confirmation code cannot be empty"
		// [Translations.SIGN_UP_ERROR]: "…", // en: "Error creating account"
		// [Translations.NO_MFA]: "…", // en: "No valid MFA method provided"
		// [Translations.INVALID_MFA]: "…", // en: "Invalid MFA type"
		// [Translations.EMPTY_CHALLENGE]: "…", // en: "Challenge response cannot be empty"
		// [Translations.NO_USER_SESSION]: "…", // en: "Failed to get the session because the user is empty"
		// [Translations.NETWORK_ERROR]: "…", // en: "Network Error"
		// [Translations.DEVICE_CONFIG]: "…", // en: "Device tracking has not been configured in this User Pool"
		// [Translations.CHATBOT_TITLE]: "…", // en: "ChatBot Lex"
		// [Translations.TEXT_INPUT_PLACEHOLDER]: "…", // en: "Write a message"
		// [Translations.VOICE_INPUT_PLACEHOLDER]: "…", // en: "Click mic to speak"
		// [Translations.CHAT_DISABLED_ERROR]: "…", // en: "Error: Either voice or text must be enabled for the chatbot"
		// [Translations.NO_BOT_NAME_ERROR]: "…", // en: "Error: Bot name must be provided to ChatBot"
	},
};

export default i18nAuthDict;
